import {useStyles} from './ElementRow.style';
import React from "react";
import CategoryIcon from "@mui/icons-material/Category";
import ElementRowProperties from "./ElementRowProperties";
import clsx from "clsx";

const ArticleCategoryElementRow: React.FC<ElementRowProperties> = ({
                                                              element,
                                                              onSelect,
                                                              className,
                                                              selected
                                                          }) => {
    const classes = useStyles();

    return (
        <div className={clsx(classes.element_row_container, className, selected && classes.active)}
             onClick={() => onSelect(element)}>
            <div className={classes.icon_info}>
                <CategoryIcon/>
            </div>

            <div className={classes.text_container}>
                <div><b>{element.name}</b></div>
                <div>{element.description}</div>
            </div>

        </div>
    )
}


export default ArticleCategoryElementRow;